export default __webpack_public_path__ + "static/media/t-online.428a1e4d.svg";